import React from 'react';

export const useAuditLogFilters = () => {
    const [searchTerm, setSearchTermState] = React.useState('');
    const [entityType, setEntityTypeState] = React.useState('ALL');
    const [action, setActionState] = React.useState('ALL');
    const [actorUserId, setActorUserIdState] = React.useState('ALL');
    const [dateFrom, setDateFromState] = React.useState('');
    const [dateTo, setDateToState] = React.useState('');
    const [limit, setLimitState] = React.useState(20);
    const [offset, setOffset] = React.useState(0);
    const [isFiltersOpen, setIsFiltersOpen] = React.useState(false);

    const setSearchTerm = React.useCallback((value) => {
        setSearchTermState(value);
        setOffset(0);
    }, []);

    const setEntityType = React.useCallback((value) => {
        setEntityTypeState(value);
        setOffset(0);
    }, []);

    const setAction = React.useCallback((value) => {
        setActionState(value);
        setOffset(0);
    }, []);

    const setActorUserId = React.useCallback((value) => {
        setActorUserIdState(value);
        setOffset(0);
    }, []);

    const setDateFrom = React.useCallback((value) => {
        setDateFromState(value);
        setOffset(0);
    }, []);

    const setDateTo = React.useCallback((value) => {
        setDateToState(value);
        setOffset(0);
    }, []);

    const setLimit = React.useCallback((value) => {
        setLimitState(Number(value) || 20);
        setOffset(0);
    }, []);

    const clearFilters = React.useCallback(() => {
        setSearchTermState('');
        setEntityTypeState('ALL');
        setActionState('ALL');
        setActorUserIdState('ALL');
        setDateFromState('');
        setDateToState('');
        setLimitState(20);
        setOffset(0);
    }, []);

    const hasActiveFilters = React.useMemo(() => Boolean(
        String(searchTerm || '').trim()
        || entityType !== 'ALL'
        || action !== 'ALL'
        || actorUserId !== 'ALL'
        || dateFrom
        || dateTo,
    ), [searchTerm, entityType, action, actorUserId, dateFrom, dateTo]);

    return {
        searchTerm,
        setSearchTerm,
        entityType,
        setEntityType,
        action,
        setAction,
        actorUserId,
        setActorUserId,
        dateFrom,
        setDateFrom,
        dateTo,
        setDateTo,
        limit,
        setLimit,
        offset,
        setOffset,
        isFiltersOpen,
        openFilters: () => setIsFiltersOpen(true),
        closeFilters: () => setIsFiltersOpen(false),
        clearFilters,
        hasActiveFilters,
    };
};